import { Component, OnInit } from '@angular/core';
import { GlobalService } from 'src/app/services/global.service';
import { BsrmhttpService } from 'src/app/services/bsrmhttp.service';
import { ActivatedRoute, Router } from '@angular/router';
import { BsrmencryptionService } from 'src/app/services/bsrmencryption.service';
import { Authdata } from 'src/app/classes/authdata.class';

@Component({
  selector: 'app-resetpassword',
  templateUrl: './resetpassword.component.html',
  styleUrls: ['./resetpassword.component.css']
})
export class ResetpasswordComponent implements OnInit {

  key: string;
  successMessage: string = "";
  errorMessage: string = "";

  email: string;
  phone: string;

  canChangePassword: boolean = false;
  data: any = {
    SecurityCode: '',
    NewPassword: '',
    ConfirmPassword: ''
  };
  clearForm() {
    this.data = {
      SecurityCode: '',
      NewPassword: '',
      ConfirmPassword: ''
    };
  }
  resetPassword(e) {
    this.successMessage = "";
    this.errorMessage = "";

    if (this.data.SecurityCode && this.data.SecurityCode.length > 0) {
      if (this.data.NewPassword && this.data.NewPassword.length > 0) {
        if (this.data.ConfirmPassword && this.data.ConfirmPassword.length > 0) {
          if (this.data.NewPassword == this.data.ConfirmPassword) {
            this.setNewPassword();
          }
          else {
            this.errorMessage = "New Password and Confirm Password not matched.";
          }
        }
        else {
          this.errorMessage = "Please enter confirm password and try again.";
        }
      }
      else {
        this.errorMessage = "Please enter new password and try again.";
      }
    }
    else {
      this.errorMessage = "Please enter security code and try again.";
    }
  }
  setNewPassword() {
    this.successMessage = "";
    this.errorMessage = "";

    this.http.post(this.globalServices.resetPasswordApi, this.data).subscribe(d => {
      this.clearForm();
      var authData = new Authdata().getData();
      this.successMessage = "Password reset successfully.";
      this.canChangePassword = false;
      if (!authData || !authData.access_key || authData.access_key.length <= 0) {
        this.successMessage += " Please login to continue.";
      }

      setTimeout(() => {
        this.successMessage = "";
        this.newPasswordErrorMessage = "";
        this.confirmPasswordErrorMessage = "";

        if (authData && authData.access_key && authData.access_key.length > 0) {
          this.router.navigate(["app"]);
        }
        else {
          this.router.navigate(["login"]);
        }
      }, 5000);
    }, e => {
      console.log(e);
      if (e.error && e.error.Message)
        this.errorMessage = e.error.Message;
      else
        this.errorMessage = "Failed to reset data. May be your security code is expired or already used.";

    });
  }
 strongPassword = new RegExp(
    "(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[^A-Za-z0-9])(?=.{8,})"
  );
  checkPassword(val: string) {
    if (val && val.trim().length < 8) {
      return "Password should contain at least 8 alphanumeric character.";
    } else {
      var isNumberExist: boolean = false;
      var isCharExist: boolean = false;

      if (!this.strongPassword.test(val)) {
        return "Password Should have to at lease a uppercase, lowercase, digit or #$!%*?& and make sure the length is min 8 in length  ";
      } else {
        return "";
      }
    }
  }

  checkPasswordOld(val: string): string {
    if (val.trim().length < 8) {
      return "Password should contain at least 8 alphanumeric character."
    }
    else {

      var isNumberExist: boolean = false;
      var isCharExist: boolean = false;

      var zeroCharCode: number = "0".charCodeAt(0);
      var nineCharCode: number = "9".charCodeAt(0);

      for (let i = 0; i < val.length; i++) {
        var charCode = val.charCodeAt(i);
        if (charCode >= zeroCharCode && charCode <= nineCharCode) {
          isNumberExist = true;
        }
        else {
          isCharExist = true;
        }
      }
      if (!isNumberExist) {
        return "Password should contain at least 1 character between 0 to 9.";
      }
      else if (!isCharExist) {
        return "Password should contain at least 1 alphabetic character.";
      }
      else {
        return "";
      }
    }
  }

  newPasswordErrorMessage: string = "";
  confirmPasswordErrorMessage: string = "";

  newPasswordChanged() {
    this.newPasswordErrorMessage = this.checkPassword(this.data.NewPassword);
    if (this.newPasswordErrorMessage.length <= 0) {
      this.checkPasswordMismatched();
    }
  }
  confirmPasswordChanged() {
    this.confirmPasswordErrorMessage = this.checkPassword(this.data.ConfirmPassword);
    console.log(this.confirmPasswordErrorMessage);
    if (this.confirmPasswordErrorMessage.length <= 0) {
      console.log('insert into confirm check.')
      this.checkPasswordMismatched();
    }
  }
  checkPasswordMismatched() {
    this.canChangePassword = false;
    console.log(this.data);

    if (this.data.SecurityCode && this.data.SecurityCode.length > 0) {
      if (this.data.NewPassword && this.data.NewPassword.length >= 8
        && this.data.ConfirmPassword && this.data.ConfirmPassword.length >= 8
        && this.data.NewPassword == this.data.ConfirmPassword) {
        this.canChangePassword = true;
      }
      else if (this.data.NewPassword && this.data.NewPassword.length >= 8
        && this.data.ConfirmPassword && this.data.ConfirmPassword.length >= 8
        && this.data.NewPassword != this.data.ConfirmPassword) {
        this.confirmPasswordErrorMessage = "Password and Confirm Password not matched.";
      }
    }
  }
  constructor(private globalServices: GlobalService, private http: BsrmhttpService, private crypto: BsrmencryptionService,
    private route: ActivatedRoute, private router: Router) {
    this.route.queryParams.subscribe(paramList => {
      this.key = paramList['key'];
      console.log(this.key);

      var splittedData = crypto.decryptedString(this.key).split("|");
      console.log(splittedData);
      var isSecured = splittedData[1];
      var userId = splittedData[2];


      if (splittedData.length > 2) {
        this.email = splittedData[3];
        this.phone = splittedData[4];
      }
    })
  }

  ngOnInit() {

  }

}
